import PouchDB from "pouchdb";
const localDB = new PouchDB("viewstate");

// Configure to sync the changes to remote Database
localDB
  .on("change", function (change) {
    console.log(change);
  })
  .on("error", function (err) {
    console.log(err);
  });

class Dbfunctions {
  //  Create a state
  
  static async  CreateState(data){
    var promise =
       localDB.put(data);
    return promise;
  }

  // Update state details
  static UpdateState(updateddoc){
 return localDB.put(updateddoc);
  
  
  }

  // Get a state by giving an ID
  static async GetState(id){
    var promise = localDB.get(id).then((doc) =>{ 
     
       return doc
     } ).catch((err) => {
      console.log(err);
      return err
    });
    return promise;
  }

  //Get all the state from Database
  static GetAllState(){
    var promise = localDB.allDocs({ include_docs: true }).then((doc) => {
      return doc.rows
    }).catch(function (err) {
      console.log(err);
    });
    return promise;
  }

  //Delete state from Database
  static DeleteSate(id){
    var promise = localDB
      .get(id)
      .then((doc) => localDB.remove(doc))
      .catch((err) => console.log(err));
    return promise;
  }
}

export default Dbfunctions;
